export const UPDATE_CANONICAL = 'UPDATE_CANONICAL';
/**
 * canonical タグの値更新
 * @param url
 * @returns {{type: string, payload: { url: string }}}
 */
export const updateCanonical = (url) => ({
    payload: { url },
    type: UPDATE_CANONICAL,
});
